import { bludeltaRequest } from './network';


export async function dashboardReport(startTime: any, endTime: any): Promise<any> {
  return bludeltaRequest('GET', `/statistics/documents/autoprocessability/report?StartTime=${startTime}&EndTime=${endTime}`);
}